export const Role = {
  GlobalAdministrator: "GlobalAdministrator",
  TenantAdministrator: "TenantAdministrator",
  User: "User",
  AdministrativeAgent: "AdministrativeAgent",
  Investor: "Investor",
}
